<div *ngIf="platformControl.value as platform">
    <div class="title">
        {{
            isInAddMode
                ? ("integrationPage.addModeAuthMethodField" | requiredFieldTitle)
                : ("integrationPage.editModeAuthMethodField" | labelsProvider) + ": " + selectedAuthMethodDisplayName
        }}
    </div>

    <mat-radio-group [formControl]="authMethodControl">
        <mat-radio-button
            *ngFor="let authMethodOption of platformToAuthenticationMethodsSelectOptions[platform]"
            (click)="$event.stopPropagation()"
            [value]="authMethodOption.id">
            {{ authMethodOption.displayName | labelsProvider }}
        </mat-radio-button>
    </mat-radio-group>
</div>
